import React from 'react';
import { SectionContainer } from '../../ticketForm/components/SectionContainer';
import { SectionBody } from '../../ticketForm/components/SectionBody';
import { SectionLine } from '../../ticketForm/components/SectionLine';
import { FormikPremiumInput } from '../../ui/inputs/customInput';
import SectionTitle from '../../ticketForm/components/SectionTitle';
import SpecialLabelText from '../../ticketForm/components/SpecialLabelText';

export const QuoteDropoffSection = ({ quoteFormBodyData }) => {
  const { showErrors, isEdit, isReadOnly, ticketDetail } = quoteFormBodyData;
  return (
    <SectionContainer>
      <SectionTitle>Dropoff</SectionTitle>
      <SectionBody>
        <SectionLine>
          <SpecialLabelText>
            {ticketDetail.order_data.dropoff.city} {ticketDetail.order_data.dropoff.country} -{' '}
            {ticketDetail.order_data.dropoff.zipcode}
          </SpecialLabelText>
        </SectionLine>
        <SectionLine>
          <FormikPremiumInput
            label="Date"
            showErrors={showErrors}
            name="order_data.dropoff.date"
            type="date"
            isRequired={true}
            isDisabled={isEdit || isReadOnly}
          />
          <FormikPremiumInput
            label="Start time"
            isRequired={true}
            showErrors={showErrors}
            name="order_data.dropoff.time_from"
            type="time"
            isDisabled={isEdit || isReadOnly}
          />
          <FormikPremiumInput
            label="End time"
            showErrors={showErrors}
            name="order_data.dropoff.time_to"
            type="time"
            isRequired={true}
            isDisabled={isEdit || isReadOnly}
          />
        </SectionLine>
      </SectionBody>
    </SectionContainer>
  );
};
